<div class="table-responsive" style="margin-bottom: 0">
    <h6>Productos de Salida</h6>
    <table class="table table-bordered" style="margin-bottom: 0">
        <thead>
            <tr>
                <th class="text-left bg-info-subtle">Producto</th>
                <th class="text-right bg-info-subtle">Cantidad Estandar</th>
                <th class="text-right bg-info-subtle">Cantidad Real</th>
                <th class="text-right bg-info-subtle">Costo Estandar</th>
                <th class="text-right bg-info-subtle">Costo Real</th>
                <th class="text-right bg-info-subtle">Costo Total Estandar</th>
                <th class="text-right bg-info-subtle">Costo Total Real</th>
                <th class="text-center bg-info-subtle"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of detailsResult">
                <td class="text-left">
                    {{
                        item.productData
                            ? item.productData.name
                            : "Desconocido"
                    }}
                </td>
                <td class="text-right">
                    {{ item.standardQuantity | number : "1.2-2" }}
                </td>
                <td class="text-right">
                    <div class="input-group-sm d-flex flex-row" *ngIf="editing[item.id]">
                        <input type="number" 
                        placeholder="Cantidad Real" 
                        class="form-control"
                        (input)="changeInput(item)"
                        [(ngModel)]="item.realQuantity"
                        >
                    </div>
                    <div *ngIf="!editing[item.id]">
                        {{ item.realQuantity | number : "1.2-2" }}
                    </div>
                </td>
                <td class="text-right">
                    {{ item.standardCost | currency:"Q" }}
                </td>
                <td class="text-right">
                    <div class="input-group-sm d-flex flex-row" *ngIf="editing[item.id]">
                        <input type="number" 
                        placeholder="Costo Real" 
                        class="form-control"
                        (input)="changeInput(item)"
                        [(ngModel)]="item.realCost"
                        >
                    </div>
                    <div *ngIf="!editing[item.id]">
                        {{ item.realCost | currency:"Q" }}
                    </div>
                </td>
                <td class="text-right">
                    {{ item.totalCostStandard | currency:"Q" }}
                </td>
                <td class="text-right">
                    {{ item.totalCostReal | currency:"Q" }}
                </td>
                <td class="text-center">
                    <div class="d-flex flex-row items-center justify-center gap-1">
                        <span class="a-hover" (click)="setEditing(item)" *ngIf="!editing[item.id]">
                            <i class="fa fa-edit text-primary"></i>
                        </span>
                        <span class="btn btn-success btn-sm" (click)="saveChanges(item)" *ngIf="editing[item.id]">
                            <i class="fa fa-save"></i>
                        </span>
                        <span class="btn btn-danger btn-sm" (click)="cancelEditing(item)" *ngIf="editing[item.id]">
                            <i class="fa fa-cancel"></i>
                        </span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
